export const convertToDate = (year: number, month: number): string => {
  return new Date(year, month).toISOString().split('T', 1)[0]
}
